import React from 'react';
import { AddPayoutProviderAccountComponentProps } from './AddPayoutProviderAccountComponent.types';
import { AddPayPalAccountContainer } from '../../containers';
import { PayoutProviderDisplay } from '../../utils/types/Entity';
import AddBankAccountContainer from '../../containers/AddBankAccountContainer/AddBankAccountContainer';

const AddPayoutProviderAccountComponent: React.FC<
  AddPayoutProviderAccountComponentProps
> = ({ provider, onBackClick, onAccountCreationSuccess }): JSX.Element => {
  return (
    {
      [PayoutProviderDisplay.Bank]: (
        <AddBankAccountContainer
          onBackClick={onBackClick}
          onAccountCreationSuccess={onAccountCreationSuccess}
        />
      ),
      [PayoutProviderDisplay.PayPal]: (
        <AddPayPalAccountContainer onBackClick={onBackClick} />
      ),
    }[provider as PayoutProviderDisplay] ?? <></>
  );
};

export default AddPayoutProviderAccountComponent;
